(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[264],{

/***/ 48422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var common_data_trustpilot_data_json__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54356);
/* harmony import */ var common_hooks_useResizeScreenModified__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77450);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FormNewsletter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32314);
/* harmony import */ var components_organisms_AboutUs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63353);
/* harmony import */ var components_organisms_Banner__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47447);
/* harmony import */ var components_organisms_IndustryNewsInsights__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93008);
/* harmony import */ var components_organisms_OurPartners__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(90895);
/* harmony import */ var components_organisms_TrustpilotFeedBack__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91630);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(85893);
















var HongKongHome = function HongKongHome(_ref) {
  var posts = _ref.posts,
      data = _ref.data;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""),
      companyName = _useState[0],
      setCompanyName = _useState[1];

  var handleInput = function handleInput(event) {
    setCompanyName(event.target.value);
  };

  var handleSubmit = function handleSubmit() {
    window.location.href = "/onboarding/register?country_id=98&company_name=".concat(companyName);
  };

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("DESKTOP"),
      screen = _useState2[0],
      setScreen = _useState2[1];

  (0,common_hooks_useResizeScreenModified__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(setScreen);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_organisms_Banner__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        minHeightBanner: "banner-min-h-600",
        title: "Jump-start your<br/>Hong Kong business<br/>with ease",
        titleProps: {
          textColor: "bg-bbc-gradient-liner1 text-transparent bg-clip-text"
        },
        description: "Take a digital route to get your Hong Kong business off the ground from day one and free you from manual administration and compliance.",
        bgColor: "bg-bbc-gradient-11 bg-[length:180%_180%] animate-[gradientAnimation_10s_ease_infinite]",
        bgStyle: {
          backgroundBlendMode: "overlay, normal, normal, normal"
        },
        leftClassName: "relative mt-4 lg:mt-0 col-12 lg:col-6 xl:col-7 z-40 ",
        leftContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: "mb-10 lg:mb-10",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
            className: "flex flex-col justify-between rounded-full py-1 pr-1 text-sm lg:h-[50px] lg:flex-row lg:bg-white",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
              className: "flex flex-grow items-center lg:px-4",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("input", {
                id: "ipt-company-name",
                placeholder: "Your company name",
                className: "mb-4 w-full truncate rounded-full bg-white px-4 py-2 outline-none lg:mb-0",
                value: companyName,
                onChange: handleInput
              })
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
              className: "lg:max-w-[237px]",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("button", {
                onClick: function onClick() {
                  return handleSubmit();
                },
                className: "h-full w-full truncate rounded-full bg-bbc-primary py-2 px-6 text-base text-white lg:text-sm xl:text-base",
                children: "Register Your Company"
              })
            })]
          })
        }),
        rightClassName: "static hidden lg:block lg:col-6 xl:col-5",
        rightContent: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.Fragment, {
          children: screen === "DESKTOP" && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: "w-full ",
            wrapper: {
              className: "bbc-banner-image-bottom-0 banner-home"
            },
            src: "/assets/images/hk/home/banner-hk-home.png",
            width: 1034,
            height: 720,
            alt: "banner-home",
            priority: true
          })
        }),
        wave: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
          className: "relative",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/images/wave/exclude-wave.svg",
            className: "h-full w-full",
            width: 1920,
            height: 95,
            wrapper: {
              className: "w-full h-full"
            },
            alt: "banner-img"
          })
        })
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_organisms_IndustryNewsInsights__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      data: posts
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_organisms_AboutUs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      data: data === null || data === void 0 ? void 0 : data.dataAboutUs,
      bgImage: "/assets/images/common/pexels-gradient.png"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_organisms_OurPartners__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("section", {
      className: "relative pt-10 lg:mb-0 lg:bg-bbc-brand-100 lg:pt-36 lg:pb-8",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "absolute -top-1 left-0 right-0 w-full",
        src: "/assets/images/wave/curve_home-wave.svg",
        width: 1920,
        height: 158,
        wrapper: {
          className: "hidden lg:block"
        },
        alt: "wave3"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          text: "What we serve",
          className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800 lg:text-bbc-40px"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
          className: "leading-bbc-26 text-bbc-gray",
          children: "We cover a wide range of digital corporate services to help your business get things done right from the start, and other supporting areas that keep it running smoothly during company operation."
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: "row mt-6 items-center lg:mt-10",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-12 text-center lg:col-6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/images/common/corporate_secretary-hk_sg.png",
              width: 540,
              height: 540,
              alt: "corporate-secretary"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-12 lg:col-5",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                as: "h3",
                text: "Corporate Secretary",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "We'll keep track of filing deadlines, relevant administration and compliance procedures for your Hong Kong company. Make time to grow your business, not your paperworks."
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                  href: "/company-secretary",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-1 hidden lg:block"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: "row mt-6 items-center lg:mt-10",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-1 hidden lg:block"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-12 order-2 mt-6 lg:col-5 lg:order-0 lg:mt-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                as: "h3",
                text: "Company Formation",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "Enjoy your freedom and flexibility of starting business from anywhere across the globe. We utilize digital onboarding platforms and client portal to streamline every steps for your great experience."
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                  href: "/company-incorporation",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-12 text-center lg:col-6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/images/hk/home/company_formation-hk-home.png",
              width: 540,
              height: 540,
              alt: "company-formation"
            })
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: "row mt-6 items-center lg:mt-10",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-12 text-center lg:col-6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/images/common/business_accounts-hk_sg.png",
              width: 540,
              height: 540,
              alt: "business-accounts"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-12 lg:col-5",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                as: "h3",
                text: "Business Accounts",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "We offer consulting and banking introduction to both traditional and alternative banking - so you can pick the right one for your specific case and navigate through all procedures in the application process."
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                  href: "/open-bank-account",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-1 hidden lg:block"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
          className: "row mt-6 items-center lg:mt-10",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-1 hidden lg:block"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-12 order-1 mt-6 lg:col-5 lg:order-0 lg:mt-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                as: "h3",
                text: "Accounting & Auditing",
                className: "mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("p", {
                className: "mb-6 leading-bbc-26",
                children: "Our qualified accounting service saves money, time and frustration for small business owners unfamiliar with accounting practices."
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
                className: "text-center lg:text-left",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                  href: "/accounting-and-auditing",
                  className: "inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white",
                  children: "Explore"
                })
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
            className: "col-12 text-center lg:col-6",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/images/common/accounting_auditing-hk_sg.png",
              width: 540,
              height: 479,
              alt: "accounting-auditing"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("div", {
      className: "mb-20 hidden lg:block",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: "w-full",
        src: "/assets/images/wave/curve_home1-wave.svg.svg",
        width: 1920,
        height: 116,
        wrapper: {
          className: "hidden lg:block"
        },
        alt: "wave4"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("section", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          className: "title-h2 mb-6 pb-0 text-center text-bbc-brand-800",
          children: "Take it from the people we\u2018ve helped"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsxs)("p", {
          className: "text-center",
          children: ["Clients talked about us on", " ", /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)("a", {
            className: "font-medium text-bbc-primary hover:text-bbc-secondary-300",
            target: "_blank",
            rel: "noreferrer",
            href: "https://www.trustpilot.com/review/bbcincorp.com",
            children: "Trustpilot"
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_organisms_TrustpilotFeedBack__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
          data: common_data_trustpilot_data_json__WEBPACK_IMPORTED_MODULE_1__/* .feedback */ .I
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(components_molecules_FormNewsletter__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      bgColor: "bg-bbc-gradient-9"
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (HongKongHome);
HongKongHome.defaultProps = {
  data: {},
  posts: []
};

/***/ }),

/***/ 67499:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var components_common_Layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19738);
/* harmony import */ var components_templates_hk__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48422);
/* harmony import */ var _data_json__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70512);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_common_Layout__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      locationRouter: "hk",
      page: data.page,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_templates_hk__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        posts: data === null || data === void 0 ? void 0 : data.posts,
        data: _data_json__WEBPACK_IMPORTED_MODULE_2__
      })
    })
  });
}

/***/ }),

/***/ 86393:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hk",
      function () {
        return __webpack_require__(67499);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70512:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"dataAboutUs":{"title":"Get to know us","description":"<p class=\\"mb-4\\"><span class=\\"text-bbc-secondary-300\\">BBCIncorp Limited Hong Kong</span> was established in 2017 with a mission to help startups and SMEs to free their resources tied up to intimidating company administration tasks, and thus speed up the process of setting up and running a business.</p><p>We know how hard it is for businesses to change in a fast-moving world, that\'s why we make it our vision from day one to deliver services that scale with time. With our proven IT infrastructure and commitment to being a digital-first service provider, we can get your company set up and managed properly in over +18 countries at minimum costs and in a reliable manner.</p>"}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,9593,9885,8352,8528,4090,9738,7447,2314,5111,2888,179], function() { return __webpack_exec__(86393); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);